"use client";
import { Menu } from "lucide-react";
import { usePathname } from "next/navigation";
import * as React from "react";

import { Image, Link } from "@/components/primitives";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent } from "@/components/ui/sheet";

export default function Header() {
  const pathname = usePathname();
  const [isMobileNavOpen, setIsMobileNavOpen] = React.useState(false);

  React.useEffect(() => {
    // Close mobile nav on route changes.
    setIsMobileNavOpen(false);
  }, [pathname]);

  return (
    <header className="bg-background/95 border-mocha/20 border-b backdrop-blur-md">
      <div className="section-container">
        <div className="flex h-16 items-center justify-between md:h-20">
          {/* Logo with golden accent */}
          <Link aria-label="Ageless home" className="flex items-center gap-3" href="/">
            <span className="from-amber to-amber/30 h-px w-10 bg-linear-to-r" />
            <Image
              alt="Ageless"
              className="h-7 w-auto md:h-10"
              height={44}
              src="/prelaunch/ageless-logo.svg"
              width={200}
            />
          </Link>

          {/* Navigation + CTA */}
          <div className="flex items-center gap-2 md:gap-6">
            {/* Desktop nav */}
            <div className="hidden items-center gap-4 md:flex md:gap-6">
              <Link className="size-sm" href="/signup">
                <Button size="sm" variant="default">
                  Sign Up
                </Button>
              </Link>
            </div>

            {/* Mobile nav (full-screen modal) */}
            <div className="md:hidden">
              <Sheet open={isMobileNavOpen} onOpenChange={setIsMobileNavOpen}>
                <Button
                  aria-label="Open navigation menu"
                  className="h-10 w-10"
                  size="icon"
                  variant="ghost"
                  onClick={() => setIsMobileNavOpen(true)}
                >
                  <Menu className="h-5 w-5" />
                </Button>

                <SheetContent className="group rounded-none p-0" side="fade">
                  <div className="flex h-full flex-col">
                    <div className="px-6 pt-6">
                      <Link
                        className="inline-flex items-center gap-3"
                        href="/"
                        onClick={() => setIsMobileNavOpen(false)}
                      >
                        <span className="from-amber to-amber/30 h-px w-10 bg-linear-to-r" />
                        <Image
                          alt="Ageless"
                          className="h-6 w-auto"
                          height={24}
                          src="/prelaunch/ageless-logo.svg"
                          width={120}
                        />
                      </Link>
                    </div>

                    <nav className="flex-1 px-6 pt-10 pb-10">
                      <div className="space-y-6">
                        <Link
                          className="type-heading-xl text-foreground w-full text-left font-light"
                          href="/signup"
                          onClick={() => setIsMobileNavOpen(false)}
                        >
                          Sign up
                        </Link>
                      </div>
                    </nav>

                    <div className="type-overline text-muted-foreground px-6 pb-6">
                      Explore Ageless AI
                    </div>
                  </div>
                </SheetContent>
              </Sheet>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
